import * as React from 'react';
import { usePersonDevicesIsp } from '../hooks';
import { ActorApiStringDisplay } from '../../../../../components/display/string';

export const PersonsDevicesISP = () => {
  const {
    data,
    isLoading,
    error,
  } = usePersonDevicesIsp();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
